import { h, defineComponent } from 'vue';
import { createColumnHelper } from '@tanstack/vue-table';
import Label from '@/components/DataTable/Label';
import { Icons, AppButton } from '@n11/so-ui-components';

const columnHelper = createColumnHelper();

// Early Settlement Status Component
const EarlySettlementStatus = defineComponent({
  name: "EarlySettlementStatus",
  props: {
    type: {
      type: String,
      default: 'Approved',
    },
    pid: {
      type: String,
      default: "",
    },
  },
  computed: {
    status() {
      if (this.type === 'Pending') {
        return { 
          text: "Talebiniz iletildi", 
          class: "yellow",
          icon: "ClockFill",
          iconColor: "#A38712"
        };
      }
      if (this.type === 'Approved') {
        return { 
          text: "Talebiniz onaylandı", 
          class: "blue",
          icon: "CheckCircle",
          iconColor: "#007AFF"
        };
      }
      if (this.type === 'EarlyPaid') {
        return { 
          text: "Erken ödeme yapıldı", 
          class: "green",
          icon: "CheckCircle",
          iconColor: "#34C759"
        };
      }
      if (this.type === 'Rejected') {
        return {
          text: "Talebiniz onaylanmadı",
          class: "red",
          icon: "MinusCircle",
          iconColor: "#FF3B30",
        };
      }
      if (this.type === 'Cancelled') {
        return { 
          text: "Talepten vazgeçtiniz", 
          class: "gray",
          icon: "CloseCircle",
          iconColor: "#8E8E93"
        };
      }
      return { text: "", class: "", icon: "", iconColor: "" };
    },
  },
  render() {
    return h('div', {
      class: ['status-wrapper', this.status.class, { disabled: false }],
      onClick: () => this.clickStatus?.()
    }, [
      h(Icons, {
        name: this.status.icon,
        color: this.status.iconColor,
        size: 'sm'
      }),
      h('span', this.status.text)
    ]);
  },
  methods: {
    clickStatus() {
      console.log('Status clicked:', this.pid, this.type);
    }
  }
});

export function earlySettlementHistoryColumns(openCancelRequestModal) {
  return [
    columnHelper.accessor('requestNumber', {
      header: () => 'Talep Numarası',
      cell: ({ getValue }) => h(Label, { content: getValue() || '-' }),
      size: 187,
      enableResizing: false,
      columnDef: {
        meta: {
          title: 'Talep Numarası',
          detachable: false,
          sortable: true,
          visible: true,
          order: 0,
        },
      },
    }),
    columnHelper.accessor('requestDate', {
      header: () => 'Talep Oluşturma Tarihi',
      cell: ({ getValue }) => h(Label, { content: getValue() || '-' }),
      size: 170,
      enableResizing: false,
      columnDef: {
        meta: {
          title: 'Talep Oluşturma Tarihi',
          detachable: false,
          sortable: true,
          visible: true,
          order: 1,
        },
      },
    }),
    columnHelper.accessor('earlySettlementDate', {
      header: () => 'Erken Ödeme Tarihi',
      cell: ({ getValue }) => h(Label, { content: getValue() || '-' }),
      size: 170,
      enableResizing: false,
      columnDef: {
        meta: {
          title: 'Erken Ödeme Tarihi',
          detachable: false,
          sortable: true,
          visible: true,
          order: 2,
        },
      },
    }),
    columnHelper.accessor('earlySettlementAmount', {
      header: () => 'Erken Ödeme Tutarı',
      cell: ({ getValue }) => h(Label, { content: getValue() || '-' }),
      size: 150,
      enableResizing: false,
      columnDef: {
        meta: {
          title: 'Erken Ödeme Tutarı',
          detachable: false,
          sortable: true,
          visible: true,
          order: 3,
        },
      },
    }),
    columnHelper.accessor('status', {
      header: 'Durum',
      cell: ({ getValue, row }) => h(EarlySettlementStatus, {
        key: row.original?.requestNumber ?? row.id,
        pid: row.original?.requestNumber ?? String(row.id),
        type: getValue(),
      }),
      size: 184,
      enableResizing: false,
      columnDef: {
        meta: {
          title: 'Durum',
          detachable: false,
          sortable: true,
          visible: true,
          order: 4,
        },
      },
    }),
    columnHelper.accessor('description', {
      header: () => 'Açıklama',
      cell: ({ getValue }) => h(Label, { content: getValue() || '-' }),
      size: 326,
      enableResizing: false,
      columnDef: {
        meta: {
          title: 'Açıklama',
          detachable: false,
          sortable: true,
          visible: true,
          order: 5,
        },
      },
    }),
    // columnHelper.accessor('actions', {
    //   header: () => 'İşlem',
    //   cell: ({ row }) => {
    //     const handleClick = () => {
    //       if (openCancelRequestModal && row.original.requestNumber) {
    //         openCancelRequestModal(row.original.requestNumber);
    //       }
    //     };

    //     return h(AppButton, {
    //       title: 'Vazgeç',
    //       secondary: true,
    //       sm: true,
    //       class: 'cancel-request-btn',
    //       onButtonClick: handleClick,
    //     });
    //   },
    //   size: 85,
    //   enableResizing: false,
    //   columnDef: {
    //     meta: {
    //       title: 'İşlem',
    //       detachable: false,
    //       sortable: false,
    //       visible: true,
    //       order: 6,
    //     },
    //   },
    // }),
  ];
}
